
// EmpresasPage

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import { Box, Select, MenuItem, FormControl, InputLabel, Button, Grid, Typography } from '@mui/material';
import ModalEmpresas from '../../components/ModalEmpresas.js';
//import axios from 'axios';
import api from '../../config/axiosConfig'; 

function EmpresasPage() {
  const { theme } = useTheme();
  const [selectedEmpresa, setSelectedEmpresa] = useState('');
  const [companies, setCompanies] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [currentEmpresa, setCurrentEmpresa] = useState(null);

useEffect(() => {
  fetchCompanies();
}, []);

  
useEffect(() => {
  const storedEmpresa = localStorage.getItem('selectedEmpresa');
  if (storedEmpresa && companies.length > 0) {
    const empresaValida = companies.find(company => company.empresa === storedEmpresa);
    if (empresaValida) {
      setSelectedEmpresa(storedEmpresa);
    } else {
      setSelectedEmpresa(''); // Se a empresa armazenada não for válida, definimos como vazio
    }
  } else {
    setSelectedEmpresa(''); // Se não houver nada no localStorage, definimos como vazio
  }
}, [companies]); // Dependência nas companies, garante que só rodará após elas serem carregadas

  
  
const fetchCompanies = () => {
  // Recupera o token do localStorage
  const token = localStorage.getItem('token'); // Substitua 'token' pelo nome correto, se necessário

  // Configura os headers da requisição
  const config = {
    headers: {
      Authorization: `Bearer ${token}` // Adiciona o token no cabeçalho Authorization
    }
  };

  // Faz a requisição GET com os headers
  //axios.get('http://localhost:8080/listarempresas', config)
  api.get('/listarempresas', config)

    .then(response => {
      const data = response.data;
      if (data.length > 0) {
        setCompanies(data);
      }
    })
    .catch(error => {
      console.error('Erro ao buscar empresas:', error);
    });
  };
  
const handleEmpresaChange = (event) => {
  const newSelectedEmpresa = event.target.value;
  setSelectedEmpresa(newSelectedEmpresa);

  const selectedEmpresaDetails = companies.find(company => company.empresa === newSelectedEmpresa);

  if (selectedEmpresaDetails) {
    localStorage.setItem('selectedEmpresa', selectedEmpresaDetails.empresa);
    localStorage.setItem('selectedEmpresaDetails', JSON.stringify({
      empresa: selectedEmpresaDetails.empresa,
      codemp: selectedEmpresaDetails.codemp,
      cnpjemp: selectedEmpresaDetails.cnpjemp,
    }));
  } else {
    localStorage.removeItem('selectedEmpresa');
    localStorage.removeItem('selectedEmpresaDetails');
  }

  window.dispatchEvent(new Event('empresaSelecionada'));
  };
  
  
  const handleOpenModal = (mode, empresa = null) => {
    setModalMode(mode);
    setCurrentEmpresa(empresa);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setCurrentEmpresa(null);
  };

  const selectedEmpresaDetails = companies.find(company => company.empresa === selectedEmpresa);

  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
      }}
    >
      <Header selectedCompany={selectedEmpresa} /> {/* Passa o estado diretamente */}

      <div style={{ marginBottom: '30px', marginTop: '30px' }}>
        <h3>Seleção da Empresa</h3>
      </div>

      <Box display="flex" justifyContent="center" marginTop="30px">
        <FormControl variant="outlined" style={{ width: '400px', backgroundColor: theme.fieldBackground }}>
          <InputLabel id="empresa-label" style={{ color: theme.color }}>
            Selecione a Empresa
          </InputLabel>

          <Select
            labelId="empresa-label"
            id="empresa-select"
            value={selectedEmpresa}
            onChange={handleEmpresaChange}
            label="Selecione a Empresa"
            disabled={companies.length === 0} // Desabilita o Select se não houver empresas
          >
            <MenuItem value="">
              <em>Selecione uma empresa</em>
            </MenuItem>

            {companies.map((company) => (
              <MenuItem key={company.codemp} value={company.empresa}>
                {company.empresa}
              </MenuItem>
            ))}
          </Select>
          

        </FormControl>
      </Box>

      <div style={{ textAlign: 'center', marginTop: '0px' }}>
        {selectedEmpresa !== 'Nenhuma Empresa Cadastrada' && selectedEmpresaDetails && (
          <Grid container spacing={2} justifyContent="center" style={{ marginTop: '0px' }}>
            <Grid item xs={12}>
              <Typography variant="body1"><strong>Empresa:</strong> {selectedEmpresaDetails.empresa}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1"><strong>Email:</strong> {selectedEmpresaDetails.email}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>Código:</strong> {selectedEmpresaDetails.codemp}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>CNPJ:</strong> {selectedEmpresaDetails.cnpjemp}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>Fone:</strong> {selectedEmpresaDetails.fone}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>Celular:</strong> {selectedEmpresaDetails.celular}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>Data de Cadastro:</strong> {selectedEmpresaDetails.dtcadastro}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>Inscrição Estadual:</strong> {selectedEmpresaDetails.inscricaoest}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1"><strong>Inscrição Municipal:</strong> {selectedEmpresaDetails.inscricaomun}</Typography>
            </Grid>
          </Grid>
        )}
      </div>

      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <Button variant="contained" color="primary" onClick={() => handleOpenModal('add')}>
          Adicionar Empresa
        </Button>
        <Button variant="contained" color="secondary" onClick={() => handleOpenModal('edit', selectedEmpresaDetails)} disabled={selectedEmpresa === 'Nenhuma Empresa Cadastrada'}>
          Editar Empresa
        </Button>
        <Button variant="contained" color="error" onClick={() => handleOpenModal('delete', selectedEmpresaDetails)} disabled={selectedEmpresa === 'Nenhuma Empresa Cadastrada'}>
          Excluir Empresa
        </Button>
      </div>

      <ModalEmpresas
        open={modalOpen}
        handleClose={handleCloseModal}
        empresa={currentEmpresa}
        mode={modalMode}
        fetchCompanies={fetchCompanies}
      />
    </div>
  );
}

export default EmpresasPage;